import { createContext } from 'react';
import { CurrencyConverterType } from '@libs/types';

export const CurrencyContext = createContext<CurrencyConverterType>(
  {} as CurrencyConverterType
);

export const CurrencyProvider = CurrencyContext.Provider;
